export const getCurrentYear = () => {
  document.querySelector('[data-year]').innerHTML = new Date().getFullYear();
}